import useTranslations from '@/i18n/useTranslations';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import './styles/AudioLoading.css';

export default function AudioLoading({ audioFile, setAudioFile }) {
  const t = useTranslations('common.forms.add_artwork');
  return (
    <>
      <div className="add-artwork-media-form__audio-loading-container">
        <Loader inline thin className="add-artwork-media-form__audio-loading-spinner"/>

        <Text
          className="add-artwork-media-form__audio-loading-text"
          paragraph>
          {t('media.uploading_audio', { progress: audioFile.progress })}
        </Text>

        <Text
          className="add-artwork-media-form__audio-loading-delete"
          onClick={()=>setAudioFile(null)}>
          {t('media.delete')}
        </Text>
      </div>
    </>
  );
}
